'use client'
import { UseQueryResult, useQuery } from '@tanstack/react-query'
import services from '../services'
import { apiResponseHandler, queryKeys } from '@/shared/api/react-query'
import { ProjectMetricsResponse } from '../../lib'
import { GetProjectMetrics } from '@/shared/api/end-points/project'

const useHook = (params: GetProjectMetrics) => {
  const queryKey = [queryKeys((a, m, p) => a.project.getProjectMetrics(params) + m.get)]
  const query = useQuery({
    queryKey,
    queryFn: async () => apiResponseHandler(await services.getMetrics(params)),
    enabled: !!params.projectId,
    refetchOnWindowFocus: false,
  })

  return {
    ...query,
    queryKey,
  } as UseQueryResult<ProjectMetricsResponse> & { queryKey: typeof queryKey }
}
export default useHook
